import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import NitroButton from './parts/NitroButton';
import Matter from 'matter-js'
import ping from '../sounds/Ping-2.mp3';

const PageNotFound = ({ qData }) => {

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()
  const [gravityState, setGravityState] = useState(false)

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
  }

  useEffect(() => {
    let w = window.innerWidth,
      h = window.innerHeight,

      Engine = Matter.Engine,
      Render = Matter.Render,
      World = Matter.World,
      Bodies = Matter.Bodies,
      Body = Matter.Body,
      Events = Matter.Events,
      MouseConstraint = Matter.MouseConstraint,
      Mouse = Matter.Mouse;

    let engine = Engine.create({})

    let render = Render.create({
      element: boxRef.current,
      engine: engine,
      //canvas: canvasRef.current,
      options: {
        width: w,
        height: h,
        background: 'transparent',
        wireframes: false,
      },
    })

    const floor = Bodies.rectangle(w / 2, h, w, 100, {
      isStatic: true,
      render: { fillStyle: 'rgba(255,255,255,0)' }
    })
    const wallLeft = Bodies.rectangle(-80, h / 2, 160, h, { isStatic: true })
    const wallRight = Bodies.rectangle(w + 80, h / 2, 160, h, { isStatic: true })
    const ceiling = Bodies.rectangle(w / 2, -40, w, 80, { isStatic: true })

    var square = Matter.Bodies.rectangle(w / 3, h / 2, w / 8, w / 8, {
      inertia: Infinity,
      rotationSpeed: 0.001,
      render: { fillStyle: '#03DAC5' }
    });
    Matter.Body.rotate(square, -0.2);

    var triangle = Matter.Bodies.polygon(w / 2, h / 1.5, 3, w / 15, {
      inertia: Infinity,
      rotationSpeed: 0.002,
      render: { fillStyle: '#03DAC5' }
    });
    Matter.Body.rotate(triangle, 0.25);

    var polygon = Matter.Bodies.polygon(w / 6, h / 1.6, 6, w / 15, {
      inertia: Infinity,
      rotationSpeed: 0.001,
      render: { fillStyle: '#03DAC5' }
    });

    var pill = Matter.Bodies.rectangle(w / 1.7, h / 1.9, w / 4, w / 20, {
      chamfer: { radius: 10 },
      render: { fillStyle: '#03DAC5' }
    });
    Matter.Body.rotate(pill, 0.55);

    var circle = Matter.Bodies.circle(w / 1.2, h / 1.5, w / 15, {
      inertia: Infinity,
      rotationSpeed: 0.001,
      render: { fillStyle: '#03DAC5' }
    });

    World.add(engine.world, [
      floor, wallLeft, wallRight, ceiling, triangle, square, polygon, circle, pill
    ]);

    // add mouse control
    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.5,
          render: {
            visible: false
          }
        }
      });

    World.add(engine.world, mouseConstraint);

    // keep the mouse in sync with rendering
    render.mouse = mouse;

    // Allow page scrolling in matter.js window
    mouse.element.removeEventListener("mousewheel", mouse.mousewheel);
    mouse.element.removeEventListener("DOMMouseScroll", mouse.mousewheel);

    // Detect clicks vs. drags
    let click = false;

    document.addEventListener('mousedown', () => click = true);
    document.addEventListener('mousemove', () => click = false);
    //document.addEventListener('mouseup', () => console.log(click ? 'click' : 'drag'));

    // Create a On-Mouseup Event-Handler
    Events.on(mouseConstraint, 'mouseup', function (event) {
      var mouseConstraint = event.source;
      var bodies = engine.world.bodies;
      var i;
      if (!mouseConstraint.bodyB) {
        for (i = 0; i < bodies.length; i++) {
          var body = bodies[i];
          // Check if clicked or dragged
          if ((body.label === 'startBtn') && (click === true)) {
            if (Matter.Bounds.contains(body.bounds, mouseConstraint.mouse.position)) {
              setGravityState(!gravityState);
              break;
            }
          }
        }
      }
    });

    function updateRotation() {
      Body.setAngle(polygon, polygon.angle - polygon.rotationSpeed);
      Body.setAngle(triangle, triangle.angle - triangle.rotationSpeed);
      Body.setAngle(square, square.angle - square.rotationSpeed);
      requestAnimationFrame(updateRotation);
    }
    window.requestAnimationFrame(updateRotation);

    Matter.Runner.run(engine)
    Render.run(render)

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)

    window.addEventListener('resize', handleResize)
  }, [gravityState])

  useEffect(() => {
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (constraints) {
      let { width, height } = constraints

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

      // Dynamically update floor and walls
      const floor = scene.engine.world.bodies[0],
        wallLeft = scene.engine.world.bodies[1],
        wallRight = scene.engine.world.bodies[2],
        ceiling = scene.engine.world.bodies[3]

      Matter.Body.setPosition(floor, {
        x: width / 2,
        y: height - 35,
      })

      Matter.Body.setPosition(wallLeft, {
        x: -80,
        y: height / 2,
      })

      Matter.Body.setPosition(wallRight, {
        x: width + 80,
        y: height / 2,
      })

    }
  }, [scene, constraints, gravityState])

  useEffect(() => {
    if (scene) {
      scene.engine.world.gravity.y = (gravityState) ? 1 : 0.004;
    }
  }, [scene, gravityState])

  let navigate = useNavigate();
  if (gravityState) {

    setTimeout(function () {
      document.getElementById("bomb").classList.add('active');
    }, 900);
    setTimeout(function () {
      // navigate to homepage
      navigate("./", { replace: true });
    }, 1700);
  }

  return (
    <>
      <div className="w-screen min-h-screen pageStyle3 flex flex-col splash-mobile" id="splash">
        <div className='grow'>
          <p className='text-center text-xs p-6'>Sorry, the URL is not valid.<br />
            Please use button below to retun to the homepage.</p>
          <h1 className='font-black text-center text-5xl md:text-8xl text-white pt-12 pb-8'>
            <span className="block">NOT</span>
            FOUND
          </h1>

        </div>
        <div className="p-6">
          <NitroButton label="Return to homepage" formIsValid={true} onClick={setGravityState} />
        </div>
      </div>
      <div id="bomb"></div>
      <div ref={boxRef} className="splash w-screen h-screen absolute top-0 left-0"></div>
    </>

  );

}

export default PageNotFound;
